<template>
  <div>
    <my-head></my-head>
    <div style="border-top: #e5e6eb solid 1px; width: 100%">
      <img :src="zoneImage" alt="" style="width: 100%;">
    </div>
    <div class="lamborghini minH">

      <div class="crumbs">
        首页 > 版权服务 >
        <span style="color: #1d2129">{{ zoneName }}</span>
      </div>
      <div class="searchs">
        <div class="sou_suo flex-left-center">
          <el-input placeholder="输入关键字搜索" class="input-with-select" v-model="input1" :validate-event="false"
            @input="(e) => (input1 = $validForbid(e))">
          </el-input>

          <img src="../assets/search.png" style="width: 28px; margin-left: 18px; cursor: pointer" alt=""
            @click="searchInput1" />
        </div>

      </div>
      <div class="shai_xuan">
        <div class="title">
          <p>筛选条件</p>
          <div class="buttons">
            <img src="../assets/copyright_services/04.png" alt="">
            <span> 清除筛选</span>
            <el-button type="primary" @click="patentList">确认筛选</el-button>
          </div>
        </div>
        <div class="cad flex-left" v-for="(item, index) in shaiXuanList" :key="index">
          <div class="name flex-end-center">{{ item.title }}</div>
          <div class="flex-left flex-wrap" style="flex: 1">
            <div class="col" v-for="(n, i) in item.list" :key="i" :class="item.col == n ? 'checked' : ''"
              @click="item.col = n">
              {{ n }}
            </div>
          </div>
        </div>

      </div>

      <!-- <div class="shou_qi flex-center">
        <img src="../assets/Subtract.png" />
        <div class="flex-center">收起</div>
      </div> -->

      <div class="jie_guo flex-between">
        <div>
          为你找到
          <span>{{ total }}</span>
          条相关结果
        </div>
        <!-- <el-select v-model="optionsvalue" placeholder="请选择" size="small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </div>

      <div class="lie_biao flex-between-left flex-wrap" v-if="introduction.length > 0 && zoneType == 0">
        <div class="content" v-for="(item, index) in introduction" :key="index" @click="details(item.id)">
          <img :src='item.workImages[0].watermark' alt="">
          <div>{{ item.workName }}</div>
          <p>{{ item.worksWriter }}</p>
          <span>{{ item.date | formatDate3 }} | 编号：{{ item.workZoneId }}</span>
        </div>
      </div>
      <div class="lie_biao flex-between-left flex-wrap" v-else-if="introduction.length > 0 && zoneType == 1">
        <div class="content_audio flex-left" v-for="(item, index) in introduction" :key="index"
          @click="details(item.id)">
          <div class="imgs">
            <img class="img1" src='../assets/audio1.png' alt="">
            <img class="img2" src='../assets/audio2.png' alt="">
          </div>

          <div class="content_right">
            <div>{{ item.workName }}</div>
            <p>{{ item.worksWriter }}</p>
            <span>{{ item.date | formatDate3 }} | 编号：{{ item.workZoneId }}</span>
            <div class="time">
              <span style="color: #165DFF;">详情</span>
              <div>
                <img src="../assets/audio3.png" alt="">
                {{ item.voiceTime }}
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="flex-center fen_ye">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="page.page" :page-size="page.size" layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import ListCard from "../components/ListCard.vue";
import CooperationCard from "../components/CooperationCard.vue";
import { getRequest } from "../api/api";
import { formatDate3, mapPropertyCategoryForRequest } from "../api/util";

export default {
  name: "lamborghini",
  components: {
    MyHead,
    MyFooter,
    ListCard,
    CooperationCard,
  },
  data() {
    return {
      introduction: [],
      tab: 1,
      shaiXuanList: [
        {
          title: "筛选类型",
          list: [
            "全部",
            "专利",
            "商业秘密",
            "商标",
            "版权",
            "集成电路",
            "其他",
          ],
          col: "全部",
        },
        {
          title: "筛选类型",
          list: [
            "全部",
            "生物医药",
            "先进制造",
            "新材料",
            "新能源",
            "农业科技",
            "人工智能",
            "航空航天",
            "信息技术",
            "集成电路",
            "其他",
          ],
          col: "全部",
        },
        // {
        //   title: "交易类型",
        //   list: ["全部", "转让", "许可", "作价投资", "其他"],
        //   col: "全部",
        // },
        // {
        //   title: "挂牌时间",
        //   list: ["全部", "一周内", "一月内", "自定义"],
        //   col: "全部",
        // },
        // {
        //   title: "挂牌价格",
        //   list: ["不限", "从高到低", "从低到高", "自定义"],
        //   col: "不限",
        // },
      ],

      cardsleft: 0,
      cardwidth: 450,
      page: {
        page: 1,
        size: 12,
      },
      total: 0,
      input1: "", //搜索框
      time1: [], //筛选时间自定义
      price1: "", //筛选价格自定义1
      price2: "", //筛选价格自定义2
      jgId: null, //当前是否为机构项目列表,有值就是
      jgList: [], //活跃企业列表
      jgObj: [], //机构详情
      zoneId: null,
      zoneName: null,
      zoneType: null,
      zoneImage: null
    };
  },
  watch: {
    page: {
      handler(newName, oldName) {
        this.patentList();
      },
      deep: true,
    },
  },
  methods: {
    // 详情
    details(id) {
      console.log(id)
      this.$router.push({
        path: '/copyright_details',
        query: {
          id,
          zoneId: this.zoneId
        }
      });
    },
    // 搜索
    searchInput1() {
      this.patentList();
    },
    zoneList() {
      getRequest({ url: "/api/v1/zone?_no_page=0" }).then((res) => {
        if (res.errcode == 200) {
          let obj = res.data.find(t => t.id == this.zoneId)
          console.log(obj)
          this.zoneName = obj.zoneName
          this.zoneType = obj.zoneType
          this.zoneImage = obj.zoneImage
        }
      });
    },


    patentList() {
      //产权类型+交易类型+翻页筛选
      let data = {
        propertyCategory: mapPropertyCategoryForRequest(
          this.shaiXuanList[0].col
        ),
        projectDomain: this.shaiXuanList[1].col,
        zoneId: this.zoneId,
        // dealWay: this.shaiXuanList[2].col,
        // enterpriseId: this.jgId,
        ...this.page,
      };
      if (data.propertyCategory == "全部") {
        data.propertyCategory = null;
      }
      if (data.projectDomain == "全部") {
        data.projectDomain = null;
      }
      // if (data.dealWay == "全部") {
      //   data.dealWay = null;
      // }

      // 搜索框筛选
      if (this.input1 && this.input1 != "") {
        data.query = this.input1;
      }


      getRequest({ url: "/api/v1/works/list", data }).then((res) => {
        if (res.errcode == 200) {
          console.log(res)

          this.introduction = res.data;
          this.total = res.totalCount;

        }
      });
    },


    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    cardsZ() {
      if (this.cardsleft < 0) {
        this.cardsleft += this.cardwidth;
      }
    },
    cardsY() {
      if (this.cardsleft >= -(this.jgList.length - 2) * this.cardwidth) {
        this.cardsleft -= this.cardwidth;
      }
    },
  },
  //过滤器
  filters: {
    formatDate3(val) {
      return formatDate3(val);
    },
  },
  created() {
    if (this.$route.query.value) {
      this.input1 = this.$route.query.value;
    }
    if (this.$route.query.jgId) {
      this.jgId = this.$route.query?.jgId;
      this.jigouDetails();
    }
    if (this.$route.query.id) {
      this.zoneId = this.$route.query?.id;
      this.patentList();
      this.zoneList()
    }
  },
};
</script>

<style lang="scss">
.ji_gou {
  background: #4080ff;
  height: 134px;
  margin-bottom: 80px;

  .ji_gou_1 {
    position: relative;
    bottom: -35px;
    box-shadow: 0px 6px 16px 0px rgba(78, 89, 105, 0.12);
  }
}

.lamborghini {
  width: 80%;
  margin: 0 auto;
  padding: 35px 0 150px;
  position: relative;

  .el-date-editor .el-range-separator {
    padding: 0;
  }

  .fen_ye {
    margin-top: 48px;
  }

  .lie_biao {
    width: 100%;

    .content {
      width: 31%;
      margin-top: 30px;
      overflow: hidden;
      cursor: pointer;

      >img {
        width: 100%;
        border-radius: 12px;
      }

      >div {
        font-size: 14px;
        font-weight: bold;
        color: #1D2129;
        line-height: 22px;
        margin-top: 12px;
      }

      >p {
        font-size: 12px;
        font-weight: 400;
        color: #4E5969;
        line-height: 20px;
      }

      >span {
        font-size: 12px;
        font-weight: 400;
        color: #86909C;
        line-height: 20px;
      }
    }

    .content_audio {
      width: 50%;
      margin-top: 30px;
      overflow: hidden;
      cursor: pointer;
      position: relative;

      .imgs {
        position: relative;

        .img1 {
          width: 160px;
          border-radius: 12px;
        }

        .img2 {
          width: 130px;
          position: absolute;
          top: 15px;
          left: 15px;
        }

      }


      .content_right {
        margin-left: 30px;

        >div {
          font-size: 14px;
          font-weight: bold;
          color: #1D2129;
          line-height: 26px;
          margin-top: 6px;
        }

        >p {
          font-size: 12px;
          font-weight: 400;
          color: #4E5969;
          line-height: 22px;
        }

        >span {
          font-size: 12px;
          font-weight: 400;
          color: #86909C;
          line-height: 22px;
        }

        .time {
          display: flex;
          position: absolute;
          bottom: 10px;
          font-size: 14px;

          img {
            width: 20px;
            margin-right: 2px;
          }

          >div {
            display: flex;
            align-items: center;
            margin-left: 10px;
            height: 26px;
            border: 1px solid #ccc;
            padding: 3px 5px;
            border-radius: 16px;
            font-size: 14px;
            color: #ccc;
            font-weight: 400;
          }
        }
      }


    }
  }

  .jie_guo {
    width: 100%;
    height: 60px;
    background: #f7f8fa;
    border-radius: 8px 8px 8px 8px;
    font-size: 14px;
    font-weight: 500;
    color: #4e5969;
    padding: 0 24px;

    span {
      color: #165dff;
    }

    .el-select {
      width: 106px;
    }
  }



  .shai_xuan {
    padding: 24px;
    width: 100%;
    border-radius: 12px 12px 12px 12px;
    opacity: 1;
    border: 1px solid #e5e6eb;

    .cad {
      font-size: 14px;
      line-height: 32px;
      font-weight: 400;
      margin-bottom: 15px;

      .name {
        color: #86909c;
        width: 60px;
        margin-right: 30px;
      }

      .col {
        margin-right: 24px;
        color: #1d2129;
        cursor: pointer;
      }

      .checked {
        color: #165dff;
      }
    }

    .title {
      font-size: 18px;
      line-height: 18px;
      font-weight: 500;
      color: #1d2129;
      padding-bottom: 16px;
      border-bottom: #e5e6eb solid 1px;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .buttons {
        display: flex;
        align-items: center;

        >img {
          width: 16px;
        }

        >span {
          font-size: 14px;
          font-weight: 400;
          color: #165DFF;
          margin-left: 4px;
          margin-right: 24px;
          cursor: pointer;

        }
      }
    }
  }

  .crumbs {
    font-size: 12px;
    color: #86909c;
    margin-bottom: 35px;
  }

  .searchs {
    width: 70%;
    margin: 0 auto 55px;

    .tabs {
      font-size: 18px;
      font-weight: 500;
      color: #86909c;
      line-height: 18px;

      &>div {
        margin-left: 24px;
        cursor: pointer;

        img {
          margin-top: 16px;
        }
      }

      .checked {
        color: #165dff;
      }
    }

    .sou_suo {
      height: 52px;
      width: 100%;
      background: #f2f3f5;
      border-radius: 8px 8px 8px 8px;
      padding: 0 18px;

      input,
      el-input {
        flex: 1;
        font-size: 16px;
        border: none;
        outline: none;
        background: #f2f3f5;
      }
    }
  }
}
</style>
